import React, { useState, useEffect, useContext } from "react";
import axios from "../../../../axios/index";
import usePriceSeprator from "../../../../hooks/usePriceSeparator";
import { Link } from "react-router-dom";

// Context
import { UserContext } from "./../../../Context/UserContextProvider";

//Styles
import styles from "../AddNewFileMainPage/AddNewFileMainPage.module.css";
import newStyle from "./NewSelectCategoryStyle.module.css";
import Dstyles from "../../DashboardFileManagement/DashboardFileManagement.module.css";
import "react-toastify/dist/ReactToastify.css";
// import userStyles from "../../../UserDashboard/UserAddNewFile/UserAddNewFile.module.css"

// Re Useable Components
import DashboardSideMenu from "../../DashboardReuseAbleComponents/DashboardSideMenu";
import ShowProfileModal from "../../DashboardFileManagement/CardDetail/ShowProfileModal";
import EditCategoryModal from "../EditCategory/EditCategoryModal";
import DashboardHeader from "../../DashboardReuseAbleComponents/DashboardHeader";
import Dropdown from "react-bootstrap/Dropdown";
import CategoryCards from "./CategoryCards";
import SubCategoryCards from "./SubCategoryCards";
import AddNewFile from "../../DashboardReuseAbleComponents/AddNewFile";
import AddSubCategory from "../AddSubCategory/AddSubCategory";

//Images
import arrowIcon from "../../../../assets/img/DashboardICons/ArrowRounded.svg";
import arrowDown from "../../../../assets/img/DashboardICons/ArrowDown.svg";
import addIcon from "../../../../assets/img/DashboardICons/AddIconBlue.svg";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const SelectCategory = props => {
  const history = useHistory();
  const { userToken, permissions } = useContext(UserContext);
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState();
  const [showPage, setShowPage] = useState({
    pageNumber: 1,
    categoriID: "",
    categoriTitle: "",
    subCategoryID: "",
    selectedSub: "",
    subIsSelected: false,
  });
  const [modalShow, setModalShow] = useState(false);
  const [editModalShow, setEditModalShow] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [userpermissions, setUserpermissions] = useState({
    isSuperUser: "",
    isConsultant: "",
  });
  const [isShowSidebar, setIsShowSidebar] = useState(true);

  useEffect(() => {
    const dataHandler = async () => {
      const apiData = await axios.get("Category/GetParentCategories", {
        headers: { authorization: "Bearer " + userToken },
      });
      if (showPage.subIsSelected) {
        const getSubCategory = await axios.get(`Category/getChild/${showPage.categoriID}`, {
          headers: { authorization: "Bearer " + userToken },
        });
        setSubCategories(getSubCategory.data.data);
      }
      setCategories(apiData.data.data);
      setIsLoading(false);
    };
    //dataHandler()
  }, [userToken, showPage.subIsSelected, showPage.categoriID]);

  useEffect(() => {
    axios
      .get("Category", {
        headers: {
          authorization: "Bearer " + userToken,
        },
      })
      .then(res => {
        setCategories(res.data?.data || []);
        setIsLoading(false);
      });
  }, []);

  useEffect(() => {
    sessionStorage.removeItem("searchData");
    sessionStorage.removeItem("pageData");
    sessionStorage.removeItem("categories");
    sessionStorage.removeItem("subCategory");
    sessionStorage.removeItem("mainCategory");
    sessionStorage.removeItem("dealType");
    sessionStorage.removeItem("filters");
  }, []);

  useEffect(() => {
    if (permissions) {
      const isSuperUser = permissions.find(item => item === 0);
      const isConsultant = permissions.find(item => item === 11);
      setUserpermissions(prev => {
        return { ...prev, isSuperUser: isSuperUser, isConsultant: isConsultant };
      });
    }
  }, [permissions]);

  let [selectedDealType, setSelectedDealType] = useState(-1); //0 for sale 1 for rent
  let [selectedMainCategory, setSSelectedMainCategory] = useState(-1);
  let [selectedSubCategory, setSelectedSubcategory] = useState(-1);
  let [selectedCategory, setSelectedCategory] = useState(-1);
  let [newFileTitle, setNewFileTitle] = useState("");

  function selectDealType(dealType) {
    setSelectedDealType(dealType);
    setShowPage(prev => {
      return { ...prev, pageNumber: 2 };
    });
  }

  function selectMainCategory(categoryId) {
    setSSelectedMainCategory(categoryId);
    setShowPage(prev => {
      return { ...prev, pageNumber: 3 };
    });
  }

  function selectSubCategory(categoryId) {
    setSelectedSubcategory(categoryId);
    setShowPage(prev => {
      return { ...prev, pageNumber: 4 };
    });
  }

  function selectCategory(categoryId) {
    setSelectedCategory(categoryId);
    setShowPage(prev => {
      return { ...prev, pageNumber: 5 };
    });
  }

  function goBackToDealType() {
    setSelectedDealType(-1);
    setShowPage(prev => {
      return { ...prev, pageNumber: 1 };
    });
  }

  function goBackToMainCategories() {
    setSSelectedMainCategory(-1);
    setShowPage(prev => {
      return { ...prev, pageNumber: 2 };
    });
  }

  function goBackToSubCategories() {
    setSelectedSubcategory(-1);
    setShowPage(prev => {
      return { ...prev, pageNumber: 3 };
    });
  }

  return (
    <>
      <style type="text/css">
        {`
                    .dropdown-toggle {
                        width: 170px;
                        height: 44px;
                        background: #f9f9f9;
                        border: 1px solid #e2e2e2;
                        border-radius: 34px;
                        margin-left: 0.75rem;
                        color: #1D1D1D;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }
                    
                    .dropdown-toggle:after,
                    .btn-success:after {
                        content: none;
                    }
                    
                    .btn-success {
                        background: #f9f9f9 !important;
                        border: 1px solid #e2e2e2 !important;
                        color: #1D1D1D !important;
                        box-shadow: none !important;
                    }
                
                    .dropdown-menu {
                        width: 170px;
                        background: #F9F9F9;
                        border: 1px solid #E1E1E1;
                        border-radius: 34px;
                    }

                    .dropdown-toggle:hover {
                        background: #f4f4f4;
                        color: #1D1D1D;
                        border-color: #e5e5e5;
                        border: 1px solid #e2e2e2;
                    }
                
                    .dropdown-item {
                        margin: .5rem 0;
                        padding: .5rem .5rem .5rem 0;
                        display: flex;
                        align-items: center;
                        justify-content: flex-start;
                        font-weight: 400;
                        font-size: 14px;
                        line-height: 22px;
                        color: #1D1D1D;
                    }
                
                    .dropdown-item:hover {
                        background: #E7EAF4 !important;
                        border-radius: 24px !important;
                        font-weight: 400;
                        font-size: 14px;
                        line-height: 22px;
                        color: #1D1D1D;
                    }
    `}
      </style>

      <ShowProfileModal show={modalShow} onHide={() => setModalShow(false)} />

      <EditCategoryModal show={editModalShow} onHide={() => setEditModalShow(false)} categories={categories} />

      {isLoading ? (
        <div className={Dstyles.loader_container}>
          <div className={Dstyles.spinner}></div>
        </div>
      ) : (
        <div className="container-fluid">
          <div className="row">
            <div className={isShowSidebar ? "col-md-9" : "col-md-12"}>
              <div className={`mt-3 px-0 ${Dstyles.container}`}>
                <DashboardHeader setIsShowSidebar={setIsShowSidebar} isShowSidebar={isShowSidebar} onClick={() => setModalShow(true)} />

                {showPage.pageNumber === 1 ? (
                  <>
                    <div className="py-2">
                      <div className="container-fluid">
                        <div className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-3 me-3" dir="rtl">
                          <div className="w-100 d-flex align-items-center justify-content-between flex-wrap mt-4 mb-2">
                            <div className="d-flex align-items-center justify-content-center">
                              <a href="#" onClick={history.goBack}>
                                <img className="ms-2" src={arrowIcon} alt="icon" />
                              </a>
                              <div className={Dstyles.text1}>ایجاد فایل جدید</div>
                            </div>
                          </div>
                          <div className={`${newStyle.main_container}`}>
                            <div className={`${newStyle.file_name_container}`}>
                              <input
                                className={`${newStyle.file_name_input}`}
                                placeholder="عنوان فایل"
                                defaultValue={newFileTitle}
                                value={newFileTitle}
                                onChange={ev => {
                                  setNewFileTitle(ev.target.value);
                                }}></input>
                            </div>
                            <div className={`${newStyle.main_categories_container}`}>
                              <div
                                className={`${newStyle.category_button}`}
                                onClick={() => {
                                  selectDealType(0);
                                }}>
                                <div className={`${newStyle.category_button_content}`}>فروش</div>
                                <div className={`${newStyle.category_button_content}`}>
                                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" style={{ width: "20px", height: "20px" }}>
                                    <path d="M47 239c-9.4 9.4-9.4 24.6 0 33.9L207 433c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97.9 256 241 113c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L47 239z" />
                                  </svg>
                                </div>
                              </div>
                              <div
                                className={`${newStyle.category_button} ${newStyle.category_button_bottom}`}
                                onClick={() => {
                                  selectDealType(1);
                                }}>
                                <div className={`${newStyle.category_button_content}`}>رهن و اجاره</div>
                                <div className={`${newStyle.category_button_content}`}>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className={`${newStyle.category_button_content}`}
                                    viewBox="0 0 320 512"
                                    style={{ width: "20px", height: "20px" }}>
                                    <path d="M47 239c-9.4 9.4-9.4 24.6 0 33.9L207 433c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97.9 256 241 113c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L47 239z" />
                                  </svg>
                                </div>
                              </div>
                              <div
                                className={`${newStyle.category_button} ${newStyle.category_button_bottom}`}
                                onClick={() => {
                                  selectDealType(2);
                                }}>
                                <div className={`${newStyle.category_button_content}`}>پیش فروش</div>
                                <div className={`${newStyle.category_button_content}`}>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className={`${newStyle.category_button_content}`}
                                    viewBox="0 0 320 512"
                                    style={{ width: "20px", height: "20px" }}>
                                    <path d="M47 239c-9.4 9.4-9.4 24.6 0 33.9L207 433c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97.9 256 241 113c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L47 239z" />
                                  </svg>
                                </div>
                              </div>
                              <div
                                className={`${newStyle.category_button} ${newStyle.category_button_bottom}`}
                                onClick={() => {
                                  selectDealType(3);
                                }}>
                                <div className={`${newStyle.category_button_content}`}>مشارکت</div>
                                <div className={`${newStyle.category_button_content}`}>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className={`${newStyle.category_button_content}`}
                                    viewBox="0 0 320 512"
                                    style={{ width: "20px", height: "20px" }}>
                                    <path d="M47 239c-9.4 9.4-9.4 24.6 0 33.9L207 433c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97.9 256 241 113c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L47 239z" />
                                  </svg>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ) : showPage.pageNumber === 2 ? (
                  <>
                    <div className={`${props.userAdd ? "p-0" : "py-2"}`}>
                      <div className={`${props.userAdd ? "p-0 container-fluid" : "container-fluid"}`}>
                        <div className={`d-flex justify-content-center flex-wrap align-items-center ${props.userAdd ? "" : "mt-2 me-3"}`} dir="rtl">
                          <div className="w-100 d-flex align-items-center justify-content-between flex-wrap mt-4 mb-2">
                            <div className="d-flex align-items-center justify-content-center">
                              <a
                                href="#"
                                onClick={() =>
                                  setShowPage(prev => {
                                    return { ...prev, pageNumber: 1 };
                                  })
                                }>
                                <img className="ms-2" src={arrowIcon} alt="icon" />
                              </a>
                              <div className={Dstyles.text1}>ایجاد فایل جدید</div>
                            </div>
                          </div>
                          <div className={`${newStyle.main_container}`}>
                            <div className={`${newStyle.file_name_container}`}>
                              <input
                                className={`${newStyle.file_name_input}`}
                                placeholder="عنوان فایل"
                                defaultValue={newFileTitle}
                                value={newFileTitle}
                                onChange={ev => {
                                  setNewFileTitle(ev.target.value);
                                }}></input>
                            </div>
                            <div className={`${newStyle.main_categories_container}`}>
                              <div
                                className={`${newStyle.categories_back_button}`}
                                onClick={() => {
                                  goBackToDealType();
                                }}>
                                <div className={`${newStyle.categories_back_button_content_svg}`}>
                                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" style={{ width: "20px", height: "20px" }}>
                                    <path d="M440.6 273.4c4.7-4.5 7.4-10.8 7.4-17.4s-2.7-12.8-7.4-17.4l-176-168c-9.6-9.2-24.8-8.8-33.9 .8s-8.8 24.8 .8 33.9L364.1 232 24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l340.1 0L231.4 406.6c-9.6 9.2-9.9 24.3-.8 33.9s24.3 9.9 33.9 .8l176-168z" />
                                  </svg>
                                </div>
                                <div className={`${newStyle.categories_back_button_content_text}`}>بازگشت به دسته بندی نوع معامله</div>
                              </div>
                              {categories.map((category, index) => {
                                if (category.dealType == selectedDealType && category.parentId == null) {
                                  let isLast =
                                    categories.filter((val, indexx) => val.dealType == selectedDealType && val.parentId == null && indexx > index).length == 0;
                                  return (
                                    <>
                                      <div
                                        className={`${newStyle.category_button} ${isLast ? newStyle.category_button_bottom : ""}`}
                                        onClick={() => {
                                          selectMainCategory(category.id);
                                        }}>
                                        <div className={`${newStyle.category_button_content}`}>{category.title}</div>
                                        <div className={`${newStyle.category_button_content}`}>
                                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" style={{ width: "20px", height: "20px" }}>
                                            <path d="M47 239c-9.4 9.4-9.4 24.6 0 33.9L207 433c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97.9 256 241 113c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L47 239z" />
                                          </svg>
                                        </div>
                                      </div>
                                    </>
                                  );
                                }
                              })}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ) : showPage.pageNumber === 3 ? (
                  <>
                    <div className={`${props.userAdd ? "p-0" : "py-2"}`}>
                      <div className={`${props.userAdd ? "p-0 container-fluid" : "container-fluid"}`}>
                        <div className={`d-flex justify-content-center flex-wrap align-items-center ${props.userAdd ? "" : "mt-2 me-3"}`} dir="rtl">
                          <div className="w-100 d-flex align-items-center justify-content-between flex-wrap mt-4 mb-2">
                            <div className="d-flex align-items-center justify-content-center">
                              <a
                                href="#"
                                onClick={() =>
                                  setShowPage(prev => {
                                    return { ...prev, pageNumber: 2 };
                                  })
                                }>
                                <img className="ms-2" src={arrowIcon} alt="icon" />
                              </a>
                              <div className={Dstyles.text1}>ایجاد فایل جدید</div>
                            </div>
                          </div>
                          <div className={`${newStyle.main_container}`}>
                            <div className={`${newStyle.file_name_container}`}>
                              <input
                                className={`${newStyle.file_name_input}`}
                                placeholder="عنوان فایل"
                                defaultValue={newFileTitle}
                                value={newFileTitle}
                                onChange={ev => {
                                  setNewFileTitle(ev.target.value);
                                }}></input>
                            </div>
                            <div className={`${newStyle.main_categories_container}`}>
                              <div
                                className={`${newStyle.categories_back_button}`}
                                onClick={() => {
                                  goBackToMainCategories();
                                }}>
                                <div className={`${newStyle.categories_back_button_content_svg}`}>
                                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" style={{ width: "20px", height: "20px" }}>
                                    <path d="M440.6 273.4c4.7-4.5 7.4-10.8 7.4-17.4s-2.7-12.8-7.4-17.4l-176-168c-9.6-9.2-24.8-8.8-33.9 .8s-8.8 24.8 .8 33.9L364.1 232 24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l340.1 0L231.4 406.6c-9.6 9.2-9.9 24.3-.8 33.9s24.3 9.9 33.9 .8l176-168z" />
                                  </svg>
                                </div>
                                <div className={`${newStyle.categories_back_button_content_text}`}>بازگشت به دسته بندی نوع کاربری</div>
                              </div>
                              {categories.map((category, index) => {
                                if (category.dealType == selectedDealType && category.parentId == selectedMainCategory) {
                                  let isLast =
                                    categories.filter(
                                      (val, indexx) => val.dealType == selectedDealType && val.parentId == selectedMainCategory && indexx > index
                                    ).length == 0;
                                  return (
                                    <>
                                      <div
                                        className={`${newStyle.category_button} ${isLast ? newStyle.category_button_bottom : ""}`}
                                        onClick={() => {
                                          selectSubCategory(category.id);
                                        }}>
                                        <div className={`${newStyle.category_button_content}`}>{category.title}</div>
                                        <div className={`${newStyle.category_button_content}`}>
                                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" style={{ width: "20px", height: "20px" }}>
                                            <path d="M47 239c-9.4 9.4-9.4 24.6 0 33.9L207 433c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97.9 256 241 113c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L47 239z" />
                                          </svg>
                                        </div>
                                      </div>
                                    </>
                                  );
                                }
                              })}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ) : showPage.pageNumber === 4 ? (
                  <>
                    <div className={`${props.userAdd ? "p-0" : "py-2"}`}>
                      <div className={`${props.userAdd ? "p-0 container-fluid" : "container-fluid"}`}>
                        <div className={`d-flex justify-content-center flex-wrap align-items-center ${props.userAdd ? "" : "mt-2 me-3"}`} dir="rtl">
                          <div className="w-100 d-flex align-items-center justify-content-between flex-wrap mt-4 mb-2">
                            <div className="d-flex align-items-center justify-content-center">
                              <a
                                href="#"
                                onClick={() =>
                                  setShowPage(prev => {
                                    return { ...prev, pageNumber: 3 };
                                  })
                                }>
                                <img className="ms-2" src={arrowIcon} alt="icon" />
                              </a>
                              <div className={Dstyles.text1}>ایجاد فایل جدید</div>
                            </div>
                          </div>
                          <div className={`${newStyle.main_container}`}>
                            <div className={`${newStyle.file_name_container}`}>
                              <input
                                className={`${newStyle.file_name_input}`}
                                placeholder="عنوان فایل"
                                defaultValue={newFileTitle}
                                value={newFileTitle}
                                onChange={ev => {
                                  setNewFileTitle(ev.target.value);
                                }}></input>
                            </div>
                            <div className={`${newStyle.main_categories_container}`}>
                              <div
                                className={`${newStyle.categories_back_button}`}
                                onClick={() => {
                                  goBackToSubCategories();
                                }}>
                                <div className={`${newStyle.categories_back_button_content_svg}`}>
                                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" style={{ width: "20px", height: "20px" }}>
                                    <path d="M440.6 273.4c4.7-4.5 7.4-10.8 7.4-17.4s-2.7-12.8-7.4-17.4l-176-168c-9.6-9.2-24.8-8.8-33.9 .8s-8.8 24.8 .8 33.9L364.1 232 24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l340.1 0L231.4 406.6c-9.6 9.2-9.9 24.3-.8 33.9s24.3 9.9 33.9 .8l176-168z" />
                                  </svg>
                                </div>
                                <div className={`${newStyle.categories_back_button_content_text}`}>بازگشت به دسته بندی نوع ملک</div>
                              </div>
                              {categories.map((category, index) => {
                                if (category.dealType == selectedDealType && category.parentId == selectedSubCategory) {
                                  let isLast =
                                    categories.filter(
                                      (val, indexx) => val.dealType == selectedDealType && val.parentId == selectedSubCategory && indexx > index
                                    ).length == 0;
                                  return (
                                    <>
                                      <div
                                        className={`${newStyle.category_button} ${isLast ? newStyle.category_button_bottom : ""}`}
                                        onClick={() => {
                                          selectCategory(category.id);
                                        }}>
                                        <div className={`${newStyle.category_button_content}`}>{category.title}</div>
                                        <div className={`${newStyle.category_button_content}`}>
                                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" style={{ width: "20px", height: "20px" }}>
                                            <path d="M47 239c-9.4 9.4-9.4 24.6 0 33.9L207 433c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97.9 256 241 113c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L47 239z" />
                                          </svg>
                                        </div>
                                      </div>
                                    </>
                                  );
                                }
                              })}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  showPage.pageNumber === 5 && (
                    <>
                      <AddNewFile
                        usePriceSeprator={usePriceSeprator}
                        title={categories.find(c => c.id == selectedCategory)?.title || "افزودن فایل"}
                        category={categories.filter(val => val.id == selectedCategory)[0]}
                        selectedTitle={newFileTitle}
                        subCategoryID={showPage.subCategoryID}
                        setState={setShowPage}
                        categoryTitle={showPage.categoriTitle}
                        setIsLoading={setIsLoading}
                        userAdd={false}
                      />
                    </>
                  )
                )}
              </div>
            </div>
            <div
              className={isShowSidebar ? "col-md-3" : "hidden"}
              style={{
                display: isShowSidebar ? "block" : "none",
              }}>
              {/* sideMenu starts */}
              <DashboardSideMenu addNewFile setIsShowSidebar={setIsShowSidebar} isShowSidebar={isShowSidebar} />
              {/* sideMenu ends */}
            </div>
          </div>
        </div>
      )}
    </>
  );

  function backHandler() {
    setShowPage(prev => {
      return { ...prev, categoriID: "", pageNumber: 1, subIsSelected: false };
    });
  }

  function addSubCategoryHandler() {
    setShowPage(prev => {
      return { ...prev, categoriID: "", pageNumber: 3, subIsSelected: false };
    });
  }
};

export default React.memo(SelectCategory);
